import { EventBySlugOutput } from "~/types/EventTypesInferred";

import { Progress } from "~/components/v3/shadcn/Progress";
import { AttendanceStatus } from "@prisma/client";
import { AttendanceStatusToTailwindColorBgFull } from "~/utils/ClientSideAttendeeHelpers";

export const CapacityBar = ({
    event,
    guests,
    className,
    emptyColor,
}: {
    event: EventBySlugOutput;
    guests?: { status: AttendanceStatus }[];
    className?: string;
    emptyColor?: string;
}) => {
    const capacity = event.capacity;
    if (!capacity) return <></>;
    if (!guests) return <></>;

    const statusCounts = guests.reduce(
        (acc, attendee) => {
            acc[attendee.status] = (acc[attendee.status] ?? 0) + 1;
            return acc;
        },
        {} as Record<AttendanceStatus, number>,
    );

    for (const s of Object.keys(statusCounts)) {
        const status = s as AttendanceStatus;
        statusCounts[status] = (100 * statusCounts[status]) / capacity;
    }

    return (
        <Progress
            className={className}
            emptyColor={emptyColor}
            segments={[
                { value: statusCounts["ATTENDING"] },
                {
                    value: statusCounts["PENDING_APPROVAL"],
                    color: AttendanceStatusToTailwindColorBgFull[
                        "PENDING_APPROVAL"
                    ],
                    info: "Pending approval",
                },
                {
                    value: statusCounts["WAITLIST"],
                    color: AttendanceStatusToTailwindColorBgFull["WAITLIST"],
                    info: "Waitlisted guests",
                },
                {
                    value: statusCounts["INVITED"],
                    color: AttendanceStatusToTailwindColorBgFull["INVITED"],
                    info: "Invited guests",
                },
            ]}
        />
    );
};
